import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-42f1d9d4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "video",
  name: "video"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createCommentVNode("<a-typography-title :level=\"1\">"),
      _createCommentVNode("  云原生及Serverless基础软件服务商"),
      _createCommentVNode("</a-typography-title>"),
      _createCommentVNode("<a-typography-paragraph>"),
      _createCommentVNode("    <span>集成本优化、高效运维、稳定性治理于一体的</span>"),
      _createCommentVNode("    <br v-if=\"$Store.Public().isGridMatch('<',$Enum.GridEnum.MD)\" />"),
      _createCommentVNode("    <span>一站式平台</span>"),
      _createCommentVNode("</a-typography-paragraph>"),
      _createElementVNode("div", {
        class: _normalizeClass(["box_video", {active:$data.expand.active}])
      }, [
        _createElementVNode("video", {
          ref: "video",
          src: $data.href.video,
          controls: "",
          preload: ""
        }, null, 8 /* PROPS */, _hoisted_3),
        _createElementVNode("i", {
          class: "video_play",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.clickPlayVideo && $options.clickPlayVideo(...args)))
        })
      ], 2 /* CLASS */)
    ])
  ]))
}